module.exports = __webpack_public_path__ + "static/csiro-logo-7a4b48484e5f3926017ded34d71df532.svg";